import moment from 'moment';
import {
    FC,
    memo,
} from 'react';
import {
    Col,
    Divider,
    Row,
    Typography,
} from 'antd';
import { useTranslation } from 'react-i18next';
import { IBooking } from '../../interfaces/booking.interface';

const { Text } = Typography;

const Information: FC<Partial<IBooking>> = ({
    createdAt,
    customerName,
    customerMobile,
    businessName,
    paymentMethod,
}: Partial<IBooking>) => {
    const { t } = useTranslation('bookings');

    return (
        <Row
            align="middle"
            justify="start"
            gutter={[32, 24]}
            style={{ width: '100%' }}
        >
            <Col className="booking__info">
                <Text className="booking__info--text-label">
                    {t('DETAIL.CREATED_AT')}
                </Text>
                <Text className="booking__info--text-value">
                    {moment(createdAt).format('DD MMM HH:mm')}
                </Text>
            </Col>

            <Divider
                type="vertical"
                style={{ height: 40 }}
            />

            <Col className="booking__info">
                <Text className="booking__info--text-label">
                    {t('DETAIL.CUSTOMER')}
                </Text>
                <Text className="booking__info--text-value">
                    {customerName}
                </Text>
            </Col>

            <Divider
                type="vertical"
                style={{ height: 40 }}
            />

            <Col className="booking__info">
                <Text className="booking__info--text-label">
                    {t('DETAIL.CUSTOMER_MOBILE')}
                </Text>
                <Text className="booking__info--text-value">
                    {customerMobile}
                </Text>
            </Col>

            <Divider
                type="vertical"
                style={{ height: 40 }}
            />

            <Col className="booking__info">
                <Text className="booking__info--text-label">
                    {t('DETAIL.BUSINESS_NAME')}
                </Text>
                <Text
                    className="booking__info--text-value"
                >
                    {businessName}
                </Text>
            </Col>

            <Divider
                type="vertical"
                style={{ height: 40 }}
            />

            <Col className="booking__info">
                <Text className="booking__info--text-label">
                    {t('DETAIL.PAYMENT_METHOD')}
                </Text>
                <Text className="booking__info--text-value">
                    {t(`ORDER_FINISHED.${paymentMethod}`)}
                </Text>
            </Col>
        </Row>
    );
};

export default memo(Information);
